export const pdf = {
  A4: {
    poweredByMonday: {
      image: '/assets/powered-by/powered-by.png',
      x: 8.5,
      y: 29,
    },
    // A4 size - marigins
    content: {
      width: 19,
      height: 27,
    },
    margins: {
      x: 1,
      y: 1,
    },
  },
};
